'use client';

import React, { useState, useEffect } from 'react';
import Input_Primary from '../Input_Primary/Input_Primary';
import { useUser } from '@/store';
import ds from '@/styles/ds/ds.module.scss';

interface Input_DateOfBirthProps {
	day: string;
	month: string;
	year: string;
	setDay: (day: string) => void;
	setMonth: (month: string) => void;
	setYear: (year: string) => void;
}

const Input_DateOfBirth = ({
	day,
	month,
	year,
	setDay,
	setMonth,
	setYear,
}: Input_DateOfBirthProps) => {
	const user = useUser();
	const dob = new Date(user?.dateOfBirth);

	useEffect(() => {
		if (user?.dateOfBirth) {
			setDay(String(dob.getUTCDate()).padStart(2, '0'));
			setMonth(String(dob.getUTCMonth() + 1).padStart(2, '0'));
			setYear(String(dob.getUTCFullYear()));
		}
	}, [user?.dateOfBirth]);

	const days = Array.from({ length: 31 }, (_, i) =>
		String(i + 1).padStart(2, '0')
	);
	const months = Array.from({ length: 12 }, (_, i) =>
		String(i + 1).padStart(2, '0')
	);
	const currentYear = new Date().getFullYear();
	const years = Array.from({ length: 100 }, (_, i) => String(currentYear - i));

	const handleChange = (type: 'day' | 'month' | 'year', value: string) => {
		if (type === 'day') setDay(value);
		if (type === 'month') setMonth(value);
		if (type === 'year') setYear(value);
	};

	return (
		<div className="flex gap-2 w-full">
			{/* Day */}
			<div className={`flex flex-col w-1/3`}>
				<label htmlFor="day" className="text-xs mb-1">
					Day*
				</label>
				<DropDownWrapper>
					<select
						id="day"
						name="day"
						value={day}
						onChange={(e) => handleChange('day', e.target.value)}
						className={`border rounded !px-3 h-10 ${ds.inputContainer} appearance-none`}
					>
						<option value="">Day</option>
						{days.map((d) => (
							<option key={d} value={d}>
								{d}
							</option>
						))}
					</select>
				</DropDownWrapper>
			</div>

			{/* Month */}
			<div className="flex flex-col w-1/3">
				<label htmlFor="month" className="text-xs mb-1">
					Month*
				</label>
				<DropDownWrapper>
					<select
						id="month"
						name="month"
						value={month}
						onChange={(e) => handleChange('month', e.target.value)}
						className={`border rounded !px-3 h-10 ${ds.inputContainer} appearance-none`}
					>
						<option value="">Month</option>
						{months.map((m) => (
							<option key={m} value={m}>
								{m}
							</option>
						))}
					</select>
				</DropDownWrapper>
			</div>

			{/* Year */}
			<div className="flex flex-col w-1/3 relative justify-center">
				<label htmlFor="year" className="text-xs mb-1">
					Year*
				</label>
				<DropDownWrapper>
					<select
						id="year"
						name="year"
						value={year}
						onChange={(e) => handleChange('year', e.target.value)}
						className={`border rounded !px-3 h-10 ${ds.inputContainer} appearance-none`}
					>
						<option value="">Year</option>
						{years.map((y) => (
							<option key={y} value={y}>
								{y}
							</option>
						))}
					</select>
				</DropDownWrapper>
			</div>

			{/* Hidden full date input */}
			<input
				type="hidden"
				name="dateOfBirth"
				value={day && month && year ? `${year}-${month}-${day}` : ''}
			/>
		</div>
	);
};

export default Input_DateOfBirth;

const DropDownWrapper = ({ children }: { children: React.ReactNode }) => {
	return (
		<div className="flex items-center relative">
			{children}
			<div className="pointer-events-none absolute inset-y-0 right-3 flex items-center h-full">
				<svg
					className="w-4 h-4"
					fill="none"
					stroke="currentColor"
					strokeWidth="2"
					viewBox="0 0 24 24"
				>
					<path
						strokeLinecap="round"
						strokeLinejoin="round"
						d="M19 9l-7 7-7-7"
					/>
				</svg>
			</div>
		</div>
	);
};

// 'use client';
// import React, { useState } from 'react';

// import Input_Primary from '../Input_Primary/Input_Primary';
// import { useUser } from '@/store';

// const Input_DateOfBirth = () => {
// 	const user = useUser();
// 	const [dob, setDob] = useState(user?.dateOfBirth || '');

// 	const formatDOB = (input: string) => {
// 		const numbers = input.replace(/\D/g, '');
// 		let formatted = '';
// 		if (numbers.length > 0) formatted += numbers.slice(0, 2);
// 		if (numbers.length > 2) formatted += '/' + numbers.slice(2, 4);
// 		if (numbers.length > 4) formatted += '/' + numbers.slice(4, 8);
// 		return formatted;
// 	};

// 	const handleDOBChange = (e: React.ChangeEvent<HTMLInputElement>) => {
// 		const input = e.target.value;
// 		const formatted = formatDOB(input);
// 		setDob(formatted);
// 	};

// 	return (
// 		<Input_Primary
// 			inputProps={{
// 				id: 'dob',
// 				type: 'text',
// 				name: 'dateOfBirth',
// 				value: dob,
// 				onChange: handleDOBChange,
// 				placeholder: 'dd/mm/yyyy',
// 			}}
// 			// inputProps={{
// 			// 	id: 'dateOfBirth',
// 			// 	type: 'date',
// 			// 	name: 'dateOfBirth',
// 			// 	value: dob,
// 			// 	onChange: handleDOBChange,
// 			// 	max: new Date().toISOString().split('T')[0], // prevents future dates
// 			// }}
// 			// error={true}
// 			label="Date of birth*"
// 			labelProps={{
// 				htmlFor: 'dateOfBirth',
// 			}}
// 		/>
// 	);
// };

// export default Input_DateOfBirth;
// 'use client';
// import React, { useRef, useState, useEffect } from 'react';
// import { useUser } from '@/store';

// const Input_DateOfBirth = () => {
// 	const user = useUser();

// 	const [day, setDay] = useState('');
// 	const [month, setMonth] = useState('');
// 	const [year, setYear] = useState('');
// 	const [error, setError] = useState('');

// 	const monthRef = useRef<HTMLInputElement>(null);
// 	const yearRef = useRef<HTMLInputElement>(null);

// 	const validateDate = (d: string, m: string, y: string) => {
// 		if (d.length !== 2 || m.length !== 2 || y.length !== 4) return '';

// 		const dd = parseInt(d, 10);
// 		const mm = parseInt(m, 10) - 1;
// 		const yyyy = parseInt(y, 10);
// 		const date = new Date(yyyy, mm, dd);

// 		const valid =
// 			date.getDate() === dd &&
// 			date.getMonth() === mm &&
// 			date.getFullYear() === yyyy;

// 		return valid ? '' : 'Invalid date';
// 	};

// 	useEffect(() => {
// 		const err = validateDate(day, month, year);
// 		setError(err);
// 	}, [day, month, year]);

// 	const handleDayChange = (e: React.ChangeEvent<HTMLInputElement>) => {
// 		const val = e.target.value.replace(/\D/g, '').slice(0, 2);
// 		setDay(val);
// 		if (val.length === 2) monthRef.current?.focus();
// 	};

// 	const handleMonthChange = (e: React.ChangeEvent<HTMLInputElement>) => {
// 		const val = e.target.value.replace(/\D/g, '').slice(0, 2);
// 		setMonth(val);
// 		if (val.length === 2) yearRef.current?.focus();
// 	};

// 	const handleYearChange = (e: React.ChangeEvent<HTMLInputElement>) => {
// 		const val = e.target.value.replace(/\D/g, '').slice(0, 4);
// 		setYear(val);
// 	};

// 	const dob = `${day}/${month}/${year}`;

// 	return (
// 		<div className="flex flex-col gap-2 w-full">
// 			<label htmlFor="dob" className="text-sm text-white">
// 				Date of birth*
// 			</label>
// 			<div className="flex gap-2">
// 				<input
// 					name="day"
// 					inputMode="numeric"
// 					value={day}
// 					onChange={handleDayChange}
// 					placeholder="DD"
// 					className={`w-[60px] text-center px-2 py-1 border rounded bg-transparent text-white ${
// 						error ? 'border-red-500' : 'border-white/20'
// 					}`}
// 				/>
// 				<input
// 					name="month"
// 					inputMode="numeric"
// 					value={month}
// 					onChange={handleMonthChange}
// 					ref={monthRef}
// 					placeholder="MM"
// 					className={`w-[60px] text-center px-2 py-1 border rounded bg-transparent text-white ${
// 						error ? 'border-red-500' : 'border-white/20'
// 					}`}
// 				/>
// 				<input
// 					name="year"
// 					inputMode="numeric"
// 					value={year}
// 					onChange={handleYearChange}
// 					ref={yearRef}
// 					placeholder="YYYY"
// 					className={`w-[80px] text-center px-2 py-1 border rounded bg-transparent text-white ${
// 						error ? 'border-red-500' : 'border-white/20'
// 					}`}
// 				/>
// 			</div>
// 			{error && <p className="text-red-500 text-sm mt-1">{error}</p>}
// 			<input type="hidden" name="dateOfBirth" value={dob} />
// 		</div>
// 	);
// };

// export default Input_DateOfBirth;
